// Display only: the API's exact strings become readable figures here and nowhere is one sent back.

const whole = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
const cents = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
// A rate as it was entered: to the cent, and further where it has more to show.
const rate = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 });

// Negative in brackets, as a finance reader expects.
export function money(value, currency = 'USD', { exact = false, asRate = false } = {}) {
  const n = Number(value);
  const digits = asRate ? rate : exact ? cents : whole;
  const text = `${currency === 'USD' ? '$' : `${currency} `}${digits.format(Math.abs(n))}`;
  return n < 0 ? `(${text})` : text;
}

export function millions(value) {
  const n = Number(value);
  const text = `$${(Math.abs(n) / 1e6).toFixed(Math.abs(n) >= 1e7 ? 0 : 1)}M`;
  return n < 0 ? `−${text}` : text;
}

const dateFormat = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: 'short', year: '2-digit' });

// An ISO date as the calendar day it names, whatever the viewer's timezone.
export const day = (iso) => (iso ? dateFormat.format(new Date(`${iso}T00:00:00`)) : '—');
